import {
  RECEIVE_PICKUP_ADDON_DATA,
  RECEIVE_PICKUP_ADDON_ERROR,
  RECEIVE_PICKUP_SUBMITTING,
  RECEIVE_PICKUP_SUBMIT_SUCCESS,
  RECEIVE_IS_FETCHING_PICKUP,
  TOGGLE_PICKUP_INSTRUCTIONS,
  UPDATE_PICKUP_INSTRUCTIONS,
  RECEIVE_PICKUP_TYPE_SELECTION,
  RECEIVE_PICKUP_DATE_SELECTION,
  RECEIVE_PICKUP_PHONE_NUMBER,
  RECEIVE_PICKUP_PHONE_NUMBER_ERROR,
  RECEIVE_PICKUP_TIME_WINDOW,
} from '../../actions/pickupAddon';

export const initialState = {
  isFetching: true,
  address: {},
  serviceProviders: [],
  options: {
    provider: [],
    date: [],
    pickupTypes: [],
  },
  form: {
    provider: '',
    narvarPaymentId: '',
    date: '',
    pickupType: null,
    instructions: '',
    phoneNumber: '',
    phoneNumberError: false,
    pickupTime: '',
  },
  email: '',
  pickupDate: '',
  error: false,
  submitting: false,
  submitted: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      address,
      serviceProviders,
      options,
      form,
      isFetching,
      submitting,
      email,
      pickupDate,
      instructions,
      pickupType,
      date,
      phoneNumber,
      phoneNumberError,
      pickupTime,
    } = {},
  },
) => {
  switch (type) {
    case RECEIVE_IS_FETCHING_PICKUP:
      return {
        ...state,
        isFetching,
      };

    case RECEIVE_PICKUP_ADDON_DATA:
      return {
        ...state,
        address,
        serviceProviders,
        options,
        form: {
          ...state.form,
          ...form,
        },
        isFetching: false,
      };

    case RECEIVE_PICKUP_ADDON_ERROR:
      return {
        ...state,
        error: true,
        isFetching: false,
        submitting: false,
      };

    case RECEIVE_PICKUP_SUBMITTING:
      return {
        ...state,
        error: false,
        submitting,
      };

    case RECEIVE_PICKUP_SUBMIT_SUCCESS:
      return {
        ...state,
        email,
        pickupDate,
        submitted: true,
        isFetching: false,
        submitting: false,
      };

    case TOGGLE_PICKUP_INSTRUCTIONS:
      return {
        ...state,
        form: {
          ...state.form,
          instructions: '',
          showInstructions: !state.form.showInstructions,
        },
      };

    case UPDATE_PICKUP_INSTRUCTIONS:
      return {
        ...state,
        form: {
          ...state.form,
          instructions,
        },
      };

    case RECEIVE_PICKUP_TYPE_SELECTION:
      return {
        ...state,
        form: {
          ...state.form,
          pickupType,
        },
      };

    case RECEIVE_PICKUP_DATE_SELECTION:
      return {
        ...state,
        form: {
          ...state.form,
          date,
        },
      };

    case RECEIVE_PICKUP_PHONE_NUMBER:
      return {
        ...state,
        form: {
          ...state.form,
          phoneNumber,
        },
      };

    case RECEIVE_PICKUP_PHONE_NUMBER_ERROR:
      return {
        ...state,
        form: {
          ...state.form,
          phoneNumberError,
        },
      };

    case RECEIVE_PICKUP_TIME_WINDOW:
      return {
        ...state,
        form: {
          ...state.form,
          pickupTime,
        },
      };

    default:
      return state;
  }
};
